module.exports = __webpack_public_path__ + "static/media/bbb-highlight.14ada211.jpg";